type PersonDisplayNameInput = {
  firstName: string;
  lastName: string;
  username: string;
};

export default function getPersonDisplayName({
  firstName,
  lastName,
  username,
}: PersonDisplayNameInput) {
  const trimmedFirstName = firstName.trim();
  const trimmedLastName = lastName.trim();
  const trimmedUsername = username.trim();

  if (trimmedFirstName && trimmedLastName) {
    return `${trimmedFirstName} ${trimmedLastName}`;
  }

  if (trimmedFirstName) {
    return trimmedFirstName;
  }

  if (trimmedLastName) {
    return trimmedLastName;
  }

  return trimmedUsername;
}
